var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panel',[_c('v-expansion-panel-header',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.question)}})]),_c('v-expansion-panel-content',[_c('pre',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.answer)}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }